export default function getUrlParameters(url = '') {
  const qs = url.split('+').join(' ');
  const params = {};
  const regexp = new RegExp(/[?&]?([^=]+)=([^&]*)/g);
  let tokens = regexp.exec(qs);
  while (tokens) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    tokens = regexp.exec(qs);
  }
  return params;
}
